import { semantic } from "../semantic/semantic";

export const datatable = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  header: {
    background: "{content.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    borderWidth: "0 0 {border.width.1} 0",
    padding: "{padding.16}",
    // sm: {
    //   padding: "0",
    // },
    // lg: {
    //   padding: "0",
    // },
  },
  headerCell: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{content.hover.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{content.hover.color}",
    gap: "0",
    padding: "{padding.10} {padding.16}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
    sm: {
      padding: "{padding.4} {padding.6}",
    },
    lg: {
      padding: "{padding.14} {padding.20}",
    },
  },
  columnTitle: {
    fontWeight: "{typography.table.heading.font.weight}",
  },
  row: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{content.hover.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
  },
  bodyCell: {
    borderColor: "{datatable.border.color}",
    padding: "{datatable.header.cell.padding}",
    sm: {
      padding: "{datatable.header.cell.sm.padding}",
    },
    lg: {
      padding: "{datatable.header.cell.lg.padding}",
    },
  },
  footerCell: {
    background: "{content.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    padding: "{datatable.header.cell.padding}",
    sm: {
      padding: "{datatable.header.cell.sm.padding}",
    },
    lg: {
      padding: "{datatable.header.cell.lg.padding}",
    },
  },
  columnFooter: {
    fontWeight: "{column.title.font.weight}",
  },
  footer: {
    background: "{content.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    borderWidth: "{border.width.1}",
    padding: "{padding.16}",
    // sm: {
    //   padding: "0",
    // },
    // lg: {
    //   padding: "0",
    // },
  },
  dropPoint: {
    color: "{primary.default}",
  },
  // columnResizer: {
  //   width: "0.5rem",
  // },
  // resizeIndicator: {
  //   width: "1px",
  //   color: "{primary.color}",
  // },
  sortIcon: {
    color: "{color.neutral.500}",
    hoverColor: "{primary.support}",
    size: "12px",
  },
  // loadingIcon: {
  //   size: "2rem",
  // },
  rowToggleButton: {
    hoverBackground: "transparent",
    selectedHoverBackground: "transparent",
    color: "{button.ui.secondary.icon.color}",
    hoverColor: "{button.ui.secondary.icon.color}",
    selectedHoverColor: "{button.ui.secondary.icon.color}",
    size: "1.75rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  filter: {
    inlineGap: "{gap.8}",
    overlaySelect: {
      background: "{overlay.select.background}",
      borderColor: "{overlay.select.border.color}",
      borderRadius: "{overlay.select.border.radius}",
      color: "{overlay.select.color}",
      shadow: "{overlay.select.shadow}",
    },
    overlayPopover: {
      background: "{overlay.popover.background}",
      borderColor: "{overlay.popover.border.color}",
      borderRadius: "{overlay.popover.border.radius}",
      color: "{overlay.popover.color}",
      shadow: "{overlay.popover.shadow}",
      padding: "{overlay.popover.padding}",
      gap: "{gap.8}",
    },
    rule: {
      borderColor: "{content.border.color}",
    },
    constraintList: {
      padding: "{list.padding}",
      gap: "{list.gap}",
    },
    constraint: {
      focusBackground: "{list.option.focus.background}",
      selectedBackground: "{list.option.selected.background}",
      selectedFocusBackground: "{list.option.selected.focus.background}",
      color: "{list.option.color}",
      focusColor: "{list.option.focus.color}",
      selectedColor: "{list.option.selected.color}",
      selectedFocusColor: "{list.option.selected.focus.color}",
      separator: {
        borderColor: "{content.border.color}",
      },
      padding: "{list.option.padding}",
      borderRadius: "{list.option.border.radius}",
    },
  },
  paginatorTop: {
    borderColor: "{datatable.border.color}",
    borderWidth: "0 0 {border.width.1} 0",
  },
  paginatorBottom: {
    borderColor: "{datatable.border.color}",
    borderWidth: "0 0 {border.width.1} 0",
  },
  colorScheme: {
    light: {
      root: {
        borderColor: "{surface.border}",
      },
      row: {
        stripedBackground: "{surface.bg-grey}",
      },
      expandedrow: {
        background: "{color.slate.100}",
      },
      bodyCell: {
        selectedBorderColor: "{datatable.border.color}",
      },
    },
    dark: {
      root: {
        borderColor: "{surface.border}",
      },
      row: {
        stripedBackground: "{surface.bg-grey}",
      },
      expandedrow: {
        background: "{color.slate.800}",
      },
      bodyCell: {
        selectedBorderColor: "{datatable.border.color}",
      },
    },
  },
  extend: {
    ui: {
      headerCell: {
        fontSize: "{typography.table.heading.font.size}",
        fontLeading: "{typography.table.heading.font.leading}",
        mobileFontSize: "{typography.mobile.table.heading.font.size}",
        mobileFontLeading: "{typography.mobile.table.heading.font.leading}",
      },
      frozenColumn: {
        borderWidth: "{border.width.1}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-datatable-thead > tr > th {
      font-size: ${dt("datatable.ui.header.cell.font.size")};
      line-height: ${dt("datatable.ui.header.cell.font.leading")};
    }

    .p-datatable-sort-icon .p-sortable-column-icon {
      height: ${dt("datatable.sort.icon.size")};
      width: auto;
    }

    .p-datatable-sm .p-datatable {
      .p-datatable-header {
        padding: calc(var(--p-datatable-header-padding) / 2);
      }

      .p-datatable-sort-icon .p-sortable-column-icon {
        height: calc(${dt("datatable.sort.icon.size")} / 4 * 3);
      }

      .p-datatable-thead > tr > th {
        font-size: calc(${dt("datatable.ui.header.cell.font.size")} / 4 * 3);
        line-height: calc(${dt("datatable.ui.header.cell.font.leading")} / 4 * 3);
        padding: calc(${dt("padding-10")} / 2);;
      }

      .p-datatable-tbody > tr > td {
        padding: calc(${dt("padding-10")} / 2);
      }
    }

    .p-datatable-th-nowrap .p-datatable .p-datatable-thead > tr > th {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .p-datatable-tbody > tr > td:has(.ui-emptystate) {
      border-width: 0;
    }

    .p-datatable-frozen-column-left:has(+ :not(.p-datatable-frozen-column-left)) {
      border-inline-end-width: ${dt("datatable.ui.frozen.column.border.width")};
    }

    .p-datatable-expanded-row {
      background: ${dt("datatable.expandedrow.background")};
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(odd) > td.p-datatable-frozen-column {
      background: ${dt("datatable.row.striped.background")};
    }

    .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(odd).p-datatable-row-selected > td.p-datatable-frozen-column {
      background: ${dt("datatable.row.selected.background")};
    }

    .p-datatable-striped.p-datatable-hoverable .p-datatable-tbody > tr:not(.p-datatable-row-selected):hover > td.p-datatable-frozen-column {
      background: ${dt("datatable.row.hover.background")};
    }

    @media (width < ${semantic.breakpoint.mobile}) {
      .p-datatable-thead > tr > th {
        font-size: ${dt("datatable.ui.header.cell.mobile.font.size")};
        line-height: ${dt("datatable.ui.header.cell.mobile.font.leading")};
        white-space: nowrap;
      }

      .p-datatable-sm .p-datatable .p-datatable-thead > tr > th {
        font-size: calc(${dt("datatable.ui.header.cell.mobile.font.size")} / 4 * 3);
        line-height: calc(${dt("datatable.ui.header.cell.mobile.font.leading")} / 4 * 3);
      }

      .p-datatable .p-paginator {
        justify-content: space-between;
      }

      .p-datatable .p-paginator-first,
      .p-datatable .p-paginator-last {
        display: none;
      }
    }
  `,
};
